import { render, staticRenderFns } from "./workRecord.vue?vue&type=template&id=6b1bd452&scoped=true&"
import script from "./workRecord.vue?vue&type=script&lang=js&"
export * from "./workRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bd452",
  null
  
)

export default component.exports